<template>
  <section class="expired-invitation">
    <AlertStateBg
      alert="FAIL_MEDIUM"
      error="It seems like your invitation has expired"
      instruction="Please reach out to your Team Manager or Account Owner to request a new email invitation."
    />
  </section>
</template>

<script>
import AlertStateBg from '@/components/shared/AlertStateBg.vue'

export default {
  name: 'ExpiredInvitation',
  components: {
    AlertStateBg,
  },
  metaInfo() {
    return {
      title: `INE - Expired Invitation`,
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.expired-invitation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-image: url('../assets/images/backgrounds/dashboard_bg.jpg');
  background-size: cover;
}
</style>
